import { EntityTypes } from 'models/entity';

/**
 * The user scene a Generic content without an entity belongs to (a list, the dashboard). A detail scene
 * sets the entity on the content instead.
 */
export enum CopilotScene {
  Dashboard = 1,
  Risks = 2,
  Processes = 3,
  Objectives = 4,
  KPIs = 5,
  MyTasks = 6,
  MyRequests = 7,
  AllTasks = 8,
  Assets = 9,
  Standards = 10,
  Requirements = 11,
  Controls = 12,
  ProcessingActivities = 13,
  Audits = 14,
}

// The entity type a scene lists. The request sends it without an id, so the API loads that entity's tools
// and reads a selection as rows of that type. The dashboard lists no single type.
export const sceneEntityType = (scene: CopilotScene): EntityTypes | undefined => {
  switch (scene) {
    case CopilotScene.Risks:
      return EntityTypes.Risk;
    case CopilotScene.Processes:
      return EntityTypes.Process;
    case CopilotScene.Objectives:
      return EntityTypes.Objective;
    case CopilotScene.KPIs:
      return EntityTypes.KPI;
    case CopilotScene.MyTasks:
    case CopilotScene.MyRequests:
    case CopilotScene.AllTasks:
      return EntityTypes.Task;
    case CopilotScene.Assets:
      return EntityTypes.Asset;
    case CopilotScene.Standards:
    case CopilotScene.Controls:
      return EntityTypes.Control;
    case CopilotScene.Requirements:
      return EntityTypes.Requirement;
    case CopilotScene.ProcessingActivities:
      return EntityTypes.ProcessingActivity;
    case CopilotScene.Audits:
      return EntityTypes.InternalAudit;
    case CopilotScene.Dashboard:
      return undefined;
  }
};
